<template>
  <div class="router-transitions container-fluid flex-grow-1 container-p-y">
    <h4 class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4">
      Settings
    </h4>
    <b-card no-body>
      <b-tabs card>
        <b-tab title="Permissions" active>
          <Permissions />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import Permissions from '@/components/settings/Permissions.vue'

export default {
  name: 'Settings',
  components: { Permissions }
}
</script>

<style scoped></style>
